module.exports = __webpack_public_path__ + "img/gplaybadge.219f60b4.png";